import React from 'react';
import { Chip } from '@mui/material';
import { AddShoppingCart as AddShoppingCartIcon } from '@mui/icons-material';
import { HiCircleStack, HiTrash, HiBookmark } from 'react-icons/hi2';
import './SavedPackageCard.css';

// Card component for displaying saved credit packages
const SavedPackageCard = ({ pkg, onRemove, onAddToCart, userType }) => {
    // Calculate remaining time for credits
    const calculateCreditRemainingTime = (expiryType, expiryValue) => {
        const now = new Date();
        let endDate;

        if (expiryType === "date") {
            endDate = new Date(expiryValue);
            endDate.setHours(23, 59, 59, 999);
        } else if (expiryType === "days") {
            endDate = new Date(now);
            endDate.setDate(now.getDate() + Number(expiryValue));
        } else {
            return "Invalid expiry type";
        }

        if (endDate <= now) return "Expired";

        let years = endDate.getFullYear() - now.getFullYear();
        let months = endDate.getMonth() - now.getMonth();
        let days = endDate.getDate() - now.getDate();

        if (days < 0) {
            months--;
            const prevMonth = new Date(endDate.getFullYear(), endDate.getMonth(), 0);
            days += prevMonth.getDate();
        }

        if (months < 0) {
            years--;
            months += 12;
        }

        const parts = [];

        if (years > 0) parts.push(`${years} year${years > 1 ? "s" : ""}`);
        if (months > 0) parts.push(`${months} month${months > 1 ? "s" : ""}`);
        if (days > 0 || parts.length === 0)
            parts.push(`${days} day${days > 1 ? "s" : ""}`);

        return parts.length > 1
            ? parts.slice(0, -1).join(", ") + " and " + parts.at(-1)
            : parts[0];
    };

    const handleAddToCart = () => {
        if (onAddToCart) {
            onAddToCart();
        }
    };

    return (
        <div className="saved-pkg-card">
            <div className="saved-pkg-content">
                <div className="saved-pkg-icon-wrapper">
                    <HiCircleStack className="saved-pkg-icon" />
                </div>

                {/* Title + sub-details stacked */}
                <div className="saved-pkg-details">
                    <h4 className="saved-pkg-title">{pkg.name}</h4>
                    <h4 className="saved-pkg-title">{pkg.credits} Credits</h4>
                    {userType === "parent" && pkg.user_code && (
                        <p className="saved-pkg-subtitle">For Student: {pkg.user_code}</p>
                    )}
                    <div className="saved-pkg-meta">
                        <span className="saved-pkg-meta-item">Active for {calculateCreditRemainingTime(pkg.credits_expiry_type, pkg.credits_expiry_duration)}</span>
                         {pkg.price_before_discount && (
                            <span className="credit-pkg-meta-item">Price before discount: {pkg.price_before_discount.toFixed(2)} {pkg.currencySymbol}</span>
                        )}
                        {pkg.discount && (
                            <span className="saved-pkg-meta-item">{pkg.discount} off</span>
                        )}
                    </div>
                </div>

                {/* Price chip */}
                <Chip
                    label={`${pkg.price.toFixed(2)} ${pkg.currencySymbol}`}
                    size="small"
                    className="saved-pkg-price-chip"
                />

                {/* Add to Cart and remove buttons grouped */}
                <div className="saved-pkg-actions">
                  <button
                    className="ph-paper-btn ph-paper-btn-cart"
                    onClick={handleAddToCart}
                  >
                    <>
                      <AddShoppingCartIcon />
                      Add to Cart
                    </>
                  </button>
                  <button
                      onClick={onRemove}
                      className="saved-pkg-remove-btn"
                      aria-label="Remove item"
                  >
                      <HiTrash />
                  </button>
                  
                </div>
            </div>
        </div>
    );
};

export default SavedPackageCard;